import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import {
  CompetencyGroupDTO,
  CompetencyGroupService,
  ReadOnlyProfileCompetencyDTO,
  ReadOnlyProfileProjectDTO,
  ReadOnlyProfileDTO,
  ReadOnlyProfileService,
  CompetencyDTO,
} from "src/shared/api/generated";
import { showLoadingSpinner } from "src/shared/operators/loading-spinner.operator";
import { EmployeeCompetencyLevelService } from "src/shared/services/employee-competency-level.service";

@Component({
  selector: "app-read-only-profile-modal",
  templateUrl: "./read-only-profile-modal.component.html",
  styleUrls: ["./read-only-profile-modal.component.scss"],
})
export class ReadOnlyProfileModalComponent {
  @Input() employeeId: number | undefined;

  profile: ReadOnlyProfileDTO = {};

  technologicalCompetencyGroup: CompetencyGroupDTO = {} as CompetencyGroupDTO;
  languageCompetencyGroup: CompetencyGroupDTO = {} as CompetencyGroupDTO;

  constructor(
    private readOnlyProfileService: ReadOnlyProfileService,
    private competencyGroupService: CompetencyGroupService,
    private spinnerService: NgxSpinnerService,
    public activeModal: NgbActiveModal,
    private employeeCompetencyLevelService: EmployeeCompetencyLevelService
  ) {}

  ngOnInit() {
    if (this.employeeId) {
      this.readOnlyProfileService
        .getReadOnlyProfileForEmployee(this.employeeId)
        .pipe(showLoadingSpinner(this.spinnerService))
        .subscribe({ next: (profile) => (this.profile = profile) });
    }

    this.getTechnologicalAndLanguageCompetencyGroups();
  }

  getTechnologicalAndLanguageCompetencyGroups() {
    this.competencyGroupService.getAllCompetencyGroups().subscribe({
      next: (competencyGroups) => {
        this.technologicalCompetencyGroup = competencyGroups.find(
          (cg) => cg.name === "Technological"
        )!;
        this.languageCompetencyGroup = competencyGroups.find(
          (cg) => cg.name === "Language"
        )!;
      },
    });
  }

  getProjects() {
    return this.profile.projects?.sort((a, b) =>
      b.year!.localeCompare(a.year!)
    );
  }

  getTechnologicalProjectCompetencies(project: ReadOnlyProfileProjectDTO): CompetencyDTO[] {
    return (
      project.competencies
        ?.filter(
          (c) =>
            c.competencyGroup?.rootGroupId ===
            this.technologicalCompetencyGroup.id
        ) ?? []
    );
  }

  getLanguageProjectCompetencies(project: ReadOnlyProfileProjectDTO): CompetencyDTO[] {
    return (
      project.competencies
        ?.filter(
          (c) =>
            c.competencyGroup?.rootGroupId ===
            this.languageCompetencyGroup.id
        ) ?? []
    );
  }

  getTechnologicalCompetencies(): ReadOnlyProfileCompetencyDTO[] {
    return (
      this.profile.competencies
        ?.filter(
          (c) =>
            c.competencyDTO?.competencyGroup.rootGroupId ===
            this.technologicalCompetencyGroup.id
        )
        .sort((a, b) => this.employeeCompetencyLevelService.getCompetencyLevel(b.level!) -
        this.employeeCompetencyLevelService.getCompetencyLevel(a.level!)) ?? []
    );
  }

  getLanguageCompetencies(): ReadOnlyProfileCompetencyDTO[] {
    return (
      this.profile.competencies
        ?.filter(
          (c) =>
            c.competencyDTO?.competencyGroup.rootGroupId ===
            this.languageCompetencyGroup.id
        )
        .sort((a, b) => this.employeeCompetencyLevelService.getCompetencyLevel(b.level!) -
        this.employeeCompetencyLevelService.getCompetencyLevel(a.level!)) ?? []
    );
  }
}
